var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',[_c('v-combobox',{attrs:{"items":_vm.items,"small-chips":"","outlined":"","multiple":"","label":_vm.labelText},on:{"input":event => { _vm.emitChange(event) }},model:{value:(_vm.selectedItems),callback:function ($$v) {_vm.selectedItems=$$v},expression:"selectedItems"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }